import { render, staticRenderFns } from "./smallSurround.vue?vue&type=template&id=5ceeba17&scoped=true&"
import script from "./smallSurround.vue?vue&type=script&lang=js&"
export * from "./smallSurround.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceeba17",
  null
  
)

export default component.exports